import React, { memo } from 'react'
import { useSelector } from 'react-redux'

import SummaryWidget from './SummaryWidget'
import stakingIcon from 'assets/staking-icon.png'
import { formatQBXCurrency } from '../../util/staking/staking.helpers'
import { selectStakingProfile } from '../../store/selectors/common'

const StakingSummary = ({ t }) => {
  const stakingProfile = useSelector(selectStakingProfile)

  return (
    <SummaryWidget
      title={t('home.staked-balance')}
      value={formatQBXCurrency(stakingProfile.stakedQBX)}
      icon={stakingIcon}
    />
  )
}

export default memo(StakingSummary)
